import Component from "./ModalForm";

export default Component;
